import React, { useEffect } from "react";
import { Redirect, Route, useHistory } from "react-router";
import NewFooter from "../footer";
import SideBar from "../sidebar";
import { useSelector } from "react-redux";

const AuthRoute = (props: any) => {
  const history = useHistory();
  const { path, title, hideSideBar, isContainer, onboarding } = props;
  const isAuthenticated = useSelector((state: any) => state?.isAuthenticated);
  const isPartnerVerified = useSelector((state: any) => state?.userData?.verified) == "VERIFIED";
  // Partners must finish the adhesion forms before they can use any feature.
  const isOnboardingLocked = !isPartnerVerified && !onboarding;

  useEffect(() => {
    if (title) {
      document.title = title;
    }
  }, [title]);

  useEffect(() => {
    if (isAuthenticated === false) {
      history.push("/entrar");
    }
  }, [isAuthenticated]);

  return (
    <div className="main-container" style={{ padding: hideSideBar && 0 }}>
      {!hideSideBar && <SideBar />}
      {isAuthenticated && isOnboardingLocked ? (
        <Redirect to="/formulario-adesao" />
      ) : isAuthenticated ? (
        <div
          className="page-content"
          style={{ minHeight: "1100px", paddingBottom: "4rem" }}
        >
          <div style={{ paddingBottom: "100px" }}>
            <div className={isContainer ? "container" : "content-block"}>
              <Route {...props} />
            </div>
          </div>
        </div>
      ) : (
        <Redirect
          to={{
            pathname: "/entrar",
            state: { from: path },
          }}
        />
      )}
      <NewFooter isPublicPage={false} />
    </div>
  );
};

export default AuthRoute;
